import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BaseService } from 'app/@core/services/base.service';
import { StorageService } from "app/@core/services/storage.service";
import { UtilitiesService } from 'app/@core/services/utilities.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { pipe } from 'rxjs';
import { finalize, mergeMap, switchMap } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'column-manager',
  styleUrls: ['./column-manager.component.scss'],
  templateUrl: './column-manager.component.html',
})
export class ColumnManagerterComponent implements OnInit {
  @Output() changed = new EventEmitter();
  @Output() reload = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();

  @Input() menuColumns;
  @Input() tableSettingKey = '';
  @Input() locationCompanyId = '';
  isChangedAnyThing = false;
  isAllSelected = false;
  columnObj: any;


   //-------------Newly Added----------------
  presetNameArray: any = [];
  presetNameArrayDefault: any = [];
  defaultPresetsName: any;
  editPresetTableFilterIDGet: any = null;
  presetName: any;
  isDefaultset: any;
  filterTableID: any
  addAssetModal?: BsModalRef;
  assetData: any;
  formBool = false;
  formData: any;
  editpresettableFilterId: any;
  isSavingPreset: any=false;

  private normalizeMenuColumns(menuColumns: any): any[] {
    if (Array.isArray(menuColumns)) {
      return menuColumns;
    }

    if (typeof menuColumns === 'string' && menuColumns.trim()) {
      try {
        const parsedColumns = JSON.parse(menuColumns);
        return Array.isArray(parsedColumns) ? parsedColumns : [];
      } catch {
        return [];
      }
    }

    return [];
  }
  
  constructor(
    public requestService: BaseService,
    public storageService: StorageService,
    private toaster: ToastrService,
    public utilityService: UtilitiesService,
    private modalService: BsModalService,
    ) {
    let companyId = this.storageService.getCompanyID();
    this.columnObj = {
    userId: localStorage.getItem('userId'),
    json: [],
    type: 'Custom',
    page: '',
    isDefault: true,
    presetName: "string",
    filterTableId: 0,
    isView: false,
    companyId: Number.isNaN(companyId) ? 0 : companyId,
    tableId: 0
    }
  }
  ngOnInit(): void {
    // Newely added code for preset management
    let presentName = localStorage.getItem("presetName")
    let presetNameDefault = localStorage.getItem("presetNameDefault")
    this.presetNameArray = JSON.parse(presentName)
    this.presetNameArrayDefault = JSON.parse(presetNameDefault)
    if (this.presetNameArray.length > 0) {
      this.presetNameArray.map(x => {
        if (x.isDefault === true) {
          this.defaultPresetsName = x.presetName
        }
      })
    }
    if (this.presetNameArrayDefault.length > 0) {
      this.presetNameArrayDefault.map(x => {
        if (x.isDefault === true) {
          this.defaultPresetsName = x.presetName
        }
      })
    }
    // End of newly added code for preset management
    this.menuColumns = this.normalizeMenuColumns(this.menuColumns);
    this.isAllSelected = this.isAllselectSlected();
  }

  toggleColumn(columnItem) {
    this.isChangedAnyThing = true;
    columnItem['isShowColumn'] = !columnItem['isShowColumn'];
    this.isAllSelected = this.isAllselectSlected();
  }

  isAllselectSlected() {
    return this.menuColumns.every(item => item.isShowColumn)
  }


  selectAll(event) {
    this.isAllSelected = event.target.checked;
    this.isChangedAnyThing = true;
    this.menuColumns.map(item => {
      item.isShowColumn = event.target.checked;
      return item;
    })
  }


  isRestoring: boolean = false;
  
  resetDefault() {
    this.isRestoring = true;
    this.requestService.getTableSettings(this.tableSettingKey, false).pipe(
      finalize(() => {
        this.isRestoring = false;
      })
    ).subscribe(response => {
      this.menuColumns = JSON.parse(response.defaultJson);
    });
    this.isAllSelected = this.isAllselectSlected();
    this.requestService.getTableSettings(this.tableSettingKey, true).pipe(
      finalize(() => {
        this.isRestoring = false;
      })
    ).subscribe((response) => {
      this.menuColumns = JSON.parse(response.defaultJson);
      this.isAllSelected = this.isAllselectSlected();
    })
  }


  drop(event: CdkDragDrop<string[]>) {
    this.isChangedAnyThing = true;
    moveItemInArray(this.menuColumns, event.previousIndex, event.currentIndex);
  }

  saveColumnsData(columnObj) {
    this.requestService.postTableSettings(this.tableSettingKey, columnObj)
      .subscribe(() => {
        this.closeModal();
        this.requestService.reloadCoulmn.next({ 'hard-reload': true });
      }, (error) => {
        console.log(error);
      });
  }

  closeModal() {
    this.closeModalEvent.emit();
  }











  //------------------------- Newly Added Functions for Preset Management ----------------------------




 applyColumn(val:any) {
    const tableSettingKey = localStorage.getItem('tableSettingKey');
    let filteredData: any = localStorage.getItem(tableSettingKey);
    const normalizedMenuColumns = this.normalizeMenuColumns(this.menuColumns);
    const serializedMenuColumns = normalizedMenuColumns.map((column: any) => {
      if (!column || typeof column !== 'object') {
        return column;
      }
      const { cellTemplate, ...rest } = column;
      return { ...rest };
    });

    localStorage.setItem(`${this.tableSettingKey}-isViewBool`, JSON.stringify(val));
    localStorage.setItem("isViewBool", JSON.stringify(val));
    localStorage.setItem(`${this.tableSettingKey}-jsonColumnData`, JSON.stringify(serializedMenuColumns));
    localStorage.setItem("jsonColumnData", JSON.stringify(serializedMenuColumns));
    localStorage.setItem("editPresetTableFilterIDGet", JSON.stringify(this.editPresetTableFilterIDGet === undefined ? 0 : this.editPresetTableFilterIDGet));

    this.isChangedAnyThing = false; // Reset after changes are applied
    if (this.editPresetTableFilterIDGet === undefined || this.editPresetTableFilterIDGet === null) {
      this.columnObj.tableId = 0
    }
    else {
      this.columnObj.tableId = this.editPresetTableFilterIDGet
    }
    this.closeModal();
    this.reload.emit(normalizedMenuColumns);
    this.columnObj.page = this.tableSettingKey;
    this.columnObj.json = serializedMenuColumns;
    this.columnObj.isDefault = this.isDefaultset;
    this.columnObj.filterTableId = this.filterTableID;
    this.columnObj.presetName = this.presetName;
    this.columnObj.isView = val;
    this.columnObj.tableId = this.editPresetTableFilterIDGet
    this.saveColumnsData(this.columnObj);
  }


  // Enable and Disable Preset
   onCheckboxChange(event: Event, presetName: any, isDefault: any, tableFilterId: any, pageName?: any) {
    this.requestService.showLoader();
    this.editPresetTableFilterIDGet = null
    let responsepreset: any = localStorage.getItem("responsePresetName");
    if (responsepreset) {
      let parseData = JSON.parse(responsepreset);
      parseData = presetName === undefined ? "system preset" : presetName;
      localStorage.setItem("responsePresetName", JSON.stringify(parseData));
    }
    this.presetName = presetName === undefined ? "system preset" : presetName;
    isDefault = !this.isDefaultset
    this.filterTableID = tableFilterId
    let enablepresetObj = {
      tableFilterId: this.filterTableID,
      userId: localStorage.getItem('userId'),
      companyId: this.columnObj.companyId,
      page: this.tableSettingKey || pageName,
      presetName: this.presetName,
      isDefault: isDefault

    }
    this.requestService.enablePreset(enablepresetObj)
      .subscribe(() => {

        this.closeModal();
        this.applyColumn(false)
      }, (error) => {
        console.log(error);
      });

    let presentName = localStorage.getItem("presetName")
    let presetNameDefault = localStorage.getItem("presetNameDefault")
    this.presetNameArray = JSON.parse(presentName)
    this.presetNameArrayDefault = JSON.parse(presetNameDefault)
    if (this.presetNameArray.length > 0) {
      this.presetNameArray.map(x => {
        if (x.isDefault === true) {
          this.defaultPresetsName = x.presetName
        }
      })
    }
    if (this.presetNameArrayDefault.length > 0) {
      this.presetNameArrayDefault.map(x => {
        if (x.isDefault === true) {
          this.defaultPresetsName = x.presetName
        }
      })
    }
    this.menuColumns = this.normalizeMenuColumns(this.menuColumns);
    this.isAllSelected = this.isAllselectSlected();
  }


   // Save preset with preset name
   presetNameForm(formValue) {
    // prevent multiple clicks
    if (this.isSavingPreset) return;
    this.isSavingPreset = true;
    this.editPresetTableFilterIDGet = formValue.editPresetId
    let obj =
    {
      presetName: formValue.saveObj.presetName,
      companyId: this.columnObj.companyId,
      userId: localStorage.getItem('userId'),
      page: this.tableSettingKey,
      tableId: this.editPresetTableFilterIDGet === undefined ? 0 : this.editPresetTableFilterIDGet
    }
     this.requestService.checkPresetName(obj)
       .subscribe(
         {
           next: (response) => {
             if (response === true || formValue.saveObj.presetName.toLowerCase() === 'system preset') {
               this.toaster.error(`Preset Name Already Exist`, 'Opps!');
               return
             }
             if (response === false) {
               this.toaster.success('Preset saved Successfully ', 'Success');
               let responsepreset: any = localStorage.getItem("responsePresetName");
               if (responsepreset) {
                 let parseData = JSON.parse(responsepreset);
                 parseData = formValue.saveObj.presetName
                 localStorage.setItem("responsePresetName", JSON.stringify(parseData));
               }
               this.presetName = formValue.saveObj.presetName;
               this.addAssetModal.hide();
               this.applyColumn(false);
             }

           }, complete: () => {
             // Allow clicks again after API completes
             this.isSavingPreset = false;
           }
         }
       );
  }


  // Delete preset
  deletePreset(val) {
    var tableFilterId = val
    Swal.fire({
      title: 'Are you sure?',
      text: "Are you sure you want to delete this preset?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.requestService.deletePresetRequest(`tablefilter/deletepreset-admin?TableId=${tableFilterId}`).subscribe(
          res => {
            this.toaster.success('Preset deleted Successfully ', 'Success');
            this.editPresetTableFilterIDGet = val;
            this.applyColumn(false);
          },
          err => console.log(err.message)
        )
      } else {
        // Optional: You can add additional code here if needed when they click 'Cancel'
      }
    });
    this.editPresetTableFilterIDGet = val;
  }

  // restore to default system preset
  restore(event: Event) {
    var presetName = undefined;
    var isDefault = undefined;
    var tableFilterId = undefined
    this.onCheckboxChange(event, presetName, isDefault, tableFilterId);
  }

 // Open Modal for Add and Edit Preset
  openModal(addAsset: TemplateRef<any>) {
    this.assetData = null;
    this.utilityService.modalConfig.class = "modal-md modal-dialog-centered";
    this.addAssetModal = this.modalService.show(
      addAsset,
      this.utilityService.modalConfig
    );
  }

  // Close Modal after Add and Edit Preset
  closeModalPreset() {
    this.addAssetModal.hide();
  }
   // Open Preset Modal and Get preset details for Edit preset
   presetNameModal(presetModalTemplate) {
    if (this.formBool === true) {
      this.openModal(presetModalTemplate);
      this.requestService.showLoader();
      this.requestService.getRequestAdmin(`tablefilter/editpreset-admin?TableId=${this.editpresettableFilterId}`).subscribe(
        (response) => {
          this.formData = response;
          this.requestService.hideLoader();
        }, (error) => {
          this.toaster.error(`Something went wrong`, 'Opps!');
          this.requestService.hideLoader();
        });
    }
    else {
      this.openModal(presetModalTemplate);
    }
  }



  // Edit preset with preset name
  editPreset(preset) {
    this.editpresettableFilterId = preset.tableFilterId
    this.formBool = !this.formBool
  }

   /**
 * Check Is All Columns are not Selected
*/
  isAllColNotSlected(): boolean {
    return this.menuColumns?.every((column: any) => !column.isShowColumn);
  }

}
